import { render, staticRenderFns } from "./Materialtoupload.vue?vue&type=template&id=68d0e6be&scoped=true&"
import script from "./Materialtoupload.vue?vue&type=script&lang=js&"
export * from "./Materialtoupload.vue?vue&type=script&lang=js&"
import style0 from "./Materialtoupload.vue?vue&type=style&index=0&id=68d0e6be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d0e6be",
  null
  
)

export default component.exports